<div class="row">
  <div class="col-12">
    <div class="mat-h3">AML</div>
  </div>
</div>

<div class="row">
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>AML officer</mat-label>
      <mat-select #officerFilterSelect multiple placeholder="All" [value]="officerFilter"
        panelClass="aml-officer-panel"
        (openedChange)="onOfficerPanelToggle($event, officerFilterSelect, officerFilterSearch)"
        (selectionChange)="onOfficerFilterChange($event.value)">
        <mat-select-trigger>{{officerFilterLabel()}}</mat-select-trigger>
        <div class="stage-presets">
          <button mat-button type="button" color="primary" (click)="selectAllOfficers()">Select all</button>
          <button mat-button type="button" color="primary" (click)="unselectAllOfficers()">Unselect all</button>
        </div>
        <div class="officer-search">
          <span class="mdi mdi-magnify" aria-hidden="true"></span>
          <input #officerFilterSearch type="text" placeholder="Search officers" aria-label="Search AML officers"
            [(ngModel)]="officerSearchText"
            (keydown)="onOfficerSearchKeydown($event, officerFilterSelect)">
        </div>
        <div class="officer-options">
          <mat-option [value]="officerMe">Me</mat-option>
          <mat-option [value]="officerUnassigned" class="officer-unassigned">Unassigned</mat-option>
          @for (candidate of candidateOptions(officerFilterSelect); track candidate.UserId) {
            <mat-option [value]="candidate.UserId">{{candidateName(candidate)}}</mat-option>
          } @empty {
            @if (officerSearchText.trim()) {
              <div class="officer-no-match">No officers match "{{officerSearchText}}"</div>
            }
          }
        </div>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>Checks</mat-label>
      <mat-select [(ngModel)]="checksFilter">
        @for (option of checksOptions; track option.value) {
          <mat-option [value]="option.value">{{option.label}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Stage</mat-label>
      <mat-select multiple placeholder="All" [(ngModel)]="stageFilter" panelClass="aml-stage-panel">
        <mat-select-trigger>{{stageFilterLabel()}}</mat-select-trigger>
        <div class="stage-presets">
          <button mat-button type="button" color="primary" (click)="selectOpenStages()">Open only</button>
          <button mat-button type="button" color="primary" (click)="selectAllStages()">Select all</button>
          <button mat-button type="button" color="primary" (click)="unselectAllStages()">Unselect all</button>
        </div>
        @for (stage of stageOptions; track stage) {
          <mat-option [value]="stage">{{stage}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field class="search">
      <input matInput type="text" placeholder="Search by application ID, entity or individual name"
        [(ngModel)]="searchFilter" (keyup.enter)="applyFilters()">
      <span class="mdi mdi-magnify" matPrefix></span>
    </mat-form-field>
  </div>
</div>

<div class="row">
  <div class="col-lg-3 col-md-6 col-sm-12">
    <aml-multi-filter label="Privacy status" [options]="privacyOptions" [(selected)]="privacyFilter" />
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <aml-multi-filter label="KYC status" [options]="kycOptions" [(selected)]="kycFilter" />
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <aml-multi-filter label="KYB status" [options]="kybOptions" [(selected)]="kybFilter" />
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <aml-multi-filter label="Highest risk" [options]="riskOptions" [(selected)]="riskFilter" />
  </div>
</div>

<div class="row">
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>Created from</mat-label>
      <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>Created to</mat-label>
      <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="queue-toolbar">
      <div class="action-buttons queue-actions">
        <button mat-flat-button color="primary" (click)="applyFilters()">Apply Filters</button>
        @if (hasFilters()) {
          <button mat-stroked-button color="primary" (click)="clearFilters()">
            <span class="mdi mdi-close"></span>
            Clear
          </button>
        }
        <button mat-stroked-button color="primary" (click)="loadData()" [disabled]="isLoading">
          <span class="mdi mdi-refresh"></span>
          Refresh
        </button>
        <button mat-stroked-button color="primary" (click)="exportCsv()" [disabled]="isExporting">
          <span class="mdi mdi-download"></span>
          Export CSV
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #checkIcon let-status>
  @if (status.icon) {
    <span class="mdi status-icon" [ngClass]="[status.icon, status.styleClass]" role="img"
      [attr.aria-label]="status.label" [matTooltip]="status.label" matTooltipPosition="below"></span>
  } @else {
    <span class="not-available" role="img" [attr.aria-label]="status.label"
      [matTooltip]="status.label" matTooltipPosition="below">&mdash;</span>
  }
</ng-template>

<ng-template #checkCount let-done="done" let-total="total" let-failed="failed">
  @if (total) {
    <span class="check-count" [class.count-failed]="failed">
      <b>{{done}}</b> / {{total}}
      @if (failed) {
        <span class="count-failures">· {{failed}} <span class="mdi mdi-close" aria-hidden="true"></span></span>
      }
    </span>
  } @else {
    <span class="muted">–</span>
  }
</ng-template>

<ng-template #riskPill let-level="level">
  @if (level) {
    <span class="risk-pill" [ngClass]="riskClass(level)">{{riskText(level)}}</span>
  } @else {
    <span class="muted">–</span>
  }
</ng-template>

<div class="row">
  <div class="col-12">
    @if (isLoading) {
      <custom-content-loader type="list"></custom-content-loader>
    }
    <div [ngClass]="{hidden: isLoading, 'table-section': true, 'pb-3': true}">
      <table mat-table [dataSource]="dataSource" class="width-100 mb-2" multiTemplateDataRows
        matSort [matSortActive]="sort.prop" [matSortDirection]="sort.dir" matSortDisableClear
        (matSortChange)="onSortChange($event)">
        <ng-container matColumnDef="applicationId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="applicationId" start="desc">App ID</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="applicationLink(element)" (click)="$event.stopPropagation()">
              {{element.applicationId}}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="stage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="stage"
            matTooltip="Sorted by pipeline order">Stage</th>
          <td mat-cell *matCellDef="let element">{{element.stageName || '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="createdAt" start="desc">Created</th>
          <td mat-cell *matCellDef="let element">{{formatDay(element.createdAt)}}</td>
        </ng-container>

        <ng-container matColumnDef="officer">
          <th mat-header-cell *matHeaderCellDef>AML officer</th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            @if (canEditOfficer) {
              <mat-form-field appearance="outline" class="officer-select" subscriptSizing="dynamic"
                [class.unassigned]="element.amlOfficerUserId == null">
                <mat-select #officerSelect [value]="element.amlOfficerUserId" placeholder="Unassigned"
                  [disabled]="isOfficerBusy(element)"
                  [attr.aria-label]="'AML officer for application ' + element.applicationId"
                  panelClass="aml-officer-panel" [panelWidth]="280"
                  (openedChange)="onOfficerPanelToggle($event, officerSelect, officerSearch)"
                  (selectionChange)="onOfficerChange(element, $event.value)">
                  <div class="officer-search">
                    <span class="mdi mdi-magnify" aria-hidden="true"></span>
                    <input #officerSearch type="text" placeholder="Search officers" aria-label="Search AML officers"
                      [(ngModel)]="officerSearchText"
                      (keydown)="onOfficerSearchKeydown($event, officerSelect)">
                  </div>
                  <div class="officer-options">
                    <mat-option [value]="null" class="officer-unassigned">Unassigned</mat-option>
                    @if (isOfficerOutsideCandidates(element)) {
                      <mat-option [value]="element.amlOfficerUserId" disabled>{{element.amlOfficerName}}</mat-option>
                    }
                    @for (candidate of candidateOptions(officerSelect); track candidate.UserId) {
                      <mat-option [value]="candidate.UserId">{{candidateName(candidate)}}</mat-option>
                    } @empty {
                      @if (officerSearchText.trim()) {
                        <div class="officer-no-match">No officers match "{{officerSearchText}}"</div>
                      }
                    }
                  </div>
                </mat-select>
              </mat-form-field>
            } @else {
              {{element.amlOfficerName || 'Unassigned'}}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="borrowingEntity">
          <th mat-header-cell *matHeaderCellDef>Borrowing entity</th>
          <td mat-cell *matCellDef="let element"
            [matTooltip]="element.borrowingEntity || ''" [matTooltipDisabled]="!element.borrowingEntity">
            <div class="ellipsis">{{element.borrowingEntity || '-'}}</div>
            <div class="date-text">{{partySummary(element)}}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="privacy">
          <th mat-header-cell *matHeaderCellDef>Privacy</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngTemplateOutlet="checkCount; context: {
              done: element.privacyCompletedCount, total: element.individualCount, failed: privacyFailedCount(element)}">
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="kyc">
          <th mat-header-cell *matHeaderCellDef>KYC</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngTemplateOutlet="checkCount; context: {
              done: element.kycCompletedCount, total: element.individualCount, failed: kycFailedCount(element)}">
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="kyb">
          <th mat-header-cell *matHeaderCellDef>KYB</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngTemplateOutlet="checkCount; context: {
              done: element.kybCompletedCount, total: element.kybEntityCount, failed: kybFailedCount(element)}">
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="risk">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="highestRisk" start="desc">Highest risk</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngTemplateOutlet="riskPill; context: {level: element.highestRiskLevel}"></ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            <button mat-icon-button
              [attr.aria-label]="(isExpanded(element) ? 'Hide' : 'Show') + ' parties for application ' + element.applicationId"
              [attr.aria-expanded]="isExpanded(element)"
              [attr.aria-controls]="detailId(element)"
              (click)="toggleExpanded(element)">
              <span class="mdi" [ngClass]="isExpanded(element) ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                aria-hidden="true"></span>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" class="expanded-row" [attr.colspan]="displayedColumns.length">
            <div class="example-element-detail"
              [@detailExpand]="isExpanded(element) ? 'expanded' : 'collapsed'">
              @if (isExpanded(element)) {
                <section class="parties" [id]="detailId(element)"
                  [attr.aria-label]="'Parties for application ' + element.applicationId">
                  @if (element.individuals.length) {
                    <table class="party-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Privacy</th>
                          <th>KYC</th>
                          <th>KYC risk</th>
                          <th>Score</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (individual of element.individuals; track individual.applicationIndividualId) {
                          <tr [class.passed]="isPassed(individual)">
                            <td>
                              <div class="ellipsis party-name">{{individual.name}}</div>
                              @if (individual.roles) {
                                <div class="date-text ellipsis">{{individual.roles}}</div>
                              }
                            </td>
                            <td>
                              <ng-container *ngTemplateOutlet="checkIcon; context: {$implicit: privacyIcon(individual)}"></ng-container>
                            </td>
                            <td>
                              <ng-container *ngTemplateOutlet="checkIcon; context: {$implicit: kycIcon(individual)}"></ng-container>
                            </td>
                            <td>
                              <ng-container *ngTemplateOutlet="riskPill; context: {level: individual.riskLevel}"></ng-container>
                            </td>
                            <td class="score">{{scoreText(individual.riskScore)}}</td>
                            <td class="party-actions">
                              @if (hasIndividualActions(individual)) {
                                <button mat-icon-button class="row-menu-trigger" [matMenuTriggerFor]="individualMenu"
                                  [attr.aria-label]="'Actions for ' + individual.name">
                                  <span class="mdi mdi-dots-vertical" aria-hidden="true"></span>
                                </button>
                                <mat-menu #individualMenu="matMenu" xPosition="before">
                                  @if (canResendPrivacy(individual)) {
                                    <button mat-menu-item [disabled]="isBusy(privacyKey(element, individual))"
                                      (click)="resendPrivacy(element, individual)">
                                      Resend privacy
                                    </button>
                                  }
                                  @if (canResendKycSms(individual)) {
                                    <button mat-menu-item [disabled]="isBusy(kycKey(element, individual))"
                                      (click)="resendKycSms(element, individual)">
                                      Resend KYC SMS
                                    </button>
                                  }
                                </mat-menu>
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                  @if (element.entities.length) {
                    <table class="party-table">
                      <thead>
                        <tr>
                          <th>Entity</th>
                          <th>KYB</th>
                          <th></th>
                          <th>KYB risk</th>
                          <th>Score</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (entity of element.entities; track entity.applicationCommercialEntityId) {
                          <tr>
                            <td>
                              <div class="ellipsis party-name">{{entity.legalName || '-'}}</div>
                              <div class="date-text ellipsis">{{businessNumber(entity)}}</div>
                            </td>
                            <td>
                              <ng-container *ngTemplateOutlet="checkIcon; context: {$implicit: kybIcon(entity)}"></ng-container>
                            </td>
                            <td></td>
                            <td>
                              <ng-container *ngTemplateOutlet="riskPill; context: {level: entity.riskLevel}"></ng-container>
                            </td>
                            <td class="score">{{scoreText(entity.riskScore)}}</td>
                            <td class="party-actions">
                              @if (canReevaluateKyb(entity)) {
                                <button mat-icon-button class="row-menu-trigger" [matMenuTriggerFor]="entityMenu"
                                  [attr.aria-label]="'Actions for ' + (entity.legalName || 'entity')">
                                  <span class="mdi mdi-dots-vertical" aria-hidden="true"></span>
                                </button>
                                <mat-menu #entityMenu="matMenu" xPosition="before">
                                  <button mat-menu-item [disabled]="isBusy(kybKey(entity))" (click)="reevaluateKyb(entity)">
                                    Re-evaluate KYB
                                  </button>
                                </mat-menu>
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                  @if (!element.individuals.length && !element.entities.length) {
                    <div class="no-records">No parties on this application</div>
                  }
                </section>
              }
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns" class="example-element-row"
          [class.example-expanded-row]="isExpanded(element)"
          (click)="toggleExpanded(element)">
        </tr>
        <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="example-detail-row"
          [class.example-expanded-detail]="isExpanded(element)"></tr>
      </table>

      @if (!dataSource.length) {
        <div class="no-records">No records found</div>
      }

      <app-custom-paginator [length]="total" [pageIndex]="offset" [pageSize]="limit"
        [pageSizeOptions]="[10, 20, 25, 50, 100]" (page)="onPagination($event)">
      </app-custom-paginator>
    </div>
  </div>
</div>
